import { isValidPhoneNumber as basicPhoneNumberCheck } from "libphonenumber-js";

const IS_E164_PHONE_NUMBER = /^\+[1-9]\d{1,14}$/;

function isValidPhoneNumber(phone: string) {
  return basicPhoneNumberCheck(phone) && IS_E164_PHONE_NUMBER.test(phone);
}

export { isValidPhoneNumber };
